var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div'),_c('div',{staticClass:"dash--main"},[_c('h2',[_vm._v("Welcome To Admin")])]),_c('div')])}]

export { render, staticRenderFns }